import { NgModule } from '@angular/core';
import { IFSedeBlockComponent } from './if-sede-block.component';
import { MaterialModule } from 'src/app/modules/material/material.module';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    MaterialModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule.forChild([
      {
        path: '',
        component: IFSedeBlockComponent
      }
    ])
  ],
  declarations: [
    IFSedeBlockComponent
  ],
  exports: [
    IFSedeBlockComponent
  ]
})
export class IFSedeBlockModule {}
